import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';
import 'moment/min/locales.js';
import {
  EventMenu,
  SchedulerBase,
  SchedulerDependencies,
  SchedulerEventDrag,
  SchedulerEventResize,
} from '@bryntum/schedulerpro';

SchedulerBase.applyDefaults({
  eventStyle: 'filled',
  autoCreate: false,
  features: {
    eventCopyPaste: false,
    rowCopyPaste: false,
    eventDragCreate: false,
    scheduleMenu: false,
    timeAxisHeaderMenu: false,
    dependencyMenu: false,
  },
});
EventMenu.applyDefaults({ items: { showDetails: false, unassignEvent: false } });
SchedulerEventDrag.applyDefaults({ snapToResource: false });
SchedulerEventResize.applyDefaults({ resizeSelected: false });
SchedulerDependencies.applyDefaults({ allowCreate: false, enableDelete: false });

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
